import { gale } from "@pistonite/celera";

export const useStyleEngine = gale({
    "pad-4": {
        padding: "4px",
    },
    "gap-4": {
        gap: "4px",
    },
    "pad-8": {
        padding: "8px",
    },
    transparent: {
        background: "transparent",
    },
});
